// src/components/App.vue
<template>
  <div id="app" class="app page-container">
    <BrowserError v-if="isIE11" />

    <div v-if="!$route.meta.hideHeader">
      <Header v-if="getUserState" />
    </div>
    <main class="main-view">
      <router-view></router-view>
    </main>
    <Footer />
    <Modals />
  </div>
</template>

<script>
import Header from './components/Header';
import Footer from './components/Footer';
import BrowserError from './components/Messaging/BrowserError';
import Modals from './components/Modals/Modals';
import { components, AmplifyEventBus } from 'aws-amplify-vue';
import { mapState } from 'vuex';
import routeNames from './util/routeNames';
import roles from './util/roles';
import router from './routes/router';
import { Auth } from 'aws-amplify'

export default {
  name: 'App',
  components: { Header, Footer, Modals, BrowserError, ...components },
  data() {
    return {
      isIE11: false
    }
  },
  computed: {
    getUserState() {
      return !!this.$store.getters.getUser;
    },
    ...mapState([
      'authState',
    ])
  },
  watch: {
    $route: {
      handler(to, from) {
        const body = document.getElementsByTagName('body')[0];
        if (from !== undefined && from.name) {
          body.classList.remove('page--' + from.name.toLowerCase()); 
        }
        if (to !== undefined && to.name) {
          body.classList.add('page--' + to.name.toLowerCase());
        }
      },
      immediate: true,
    }
  },
  mounted() {
    AmplifyEventBus.$on('authState', async (state) => {
      if (state === 'signedOut') {
        this.$store.dispatch('logout');
        router.push(routeNames.AUTH.PATH);
      }

      if (state === 'signedIn') {
        const user = await Auth.currentAuthenticatedUser();
        if (user.attributes['custom:role'] === roles.ADMIN) {
          router.push(routeNames.ADMIN.PATH);
        } else {
          router.push(routeNames.ADDFAMILY.PATH);
        }
      }

      this.$store.dispatch('setAuthState', state);
    });

    this.checkIE11();
  },
  methods: {
    checkIE11() {
      let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
      this.isIE11 = isIE11;
    }
  }
}
</script>

<style>
  @import url('https://fonts.googleapis.com/css?family=Montserrat:400,600,700&display=swap');
  .clickable {
    cursor: pointer;
  }
</style>
